import { initMonitoring } from './sentry';

// Imported first by main.tsx: the SDK must be initialised before the router module is evaluated,
// otherwise wrapCreateBrowserRouter cannot instrument it and transactions fall back to raw URLs.
initMonitoring();
